import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TooltipArrow extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tooltip__arrow',
            className,
        ];
    }

}

TooltipArrow.propTypes = propTypes;

TooltipArrow.defaultProps = defaultProps;

export default TooltipArrow;
